import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import App from './app/App';
import Landing from './landing_new/Landing';
import { LanguageProvider } from './landing_new/i18n';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/app/*" element={<App />} />
          {/* Przekierowanie dla kompatybilności, jeśli ktoś wejdzie na stary url bez /app/ a z hashem */}
          <Route path="/recipes" element={<Navigate to="/app/#/recipes" replace />} />
          <Route path="/inventory" element={<Navigate to="/app/#/inventory" replace />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
